import React from 'react';

const Home = () => {
  return (
    <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'lightgray',
      paddingTop: '50px'
    }}
    >
      <div>
      <h1>Home</h1>
      <p>As a graduate in Electronic and Telecommunications Engineering and a professional with two years of experience in network
automation engineering at an InSync Information Technologies. I have working experience in systems engineering tasks and confident
enough about it. With a keen interest in these emerging technologies, I have been self-learning and exploring various concepts and
tools. I possess strong technical skills and have worked collaboratively in teams to design and implement systems for the company's
products and has the ability to navigate through different tech stacks with ease.</p>
      </div>
    </div>
  );
};
  
export default Home;